import { CheckCircle2 } from "lucide-react";
import { SiteHeader } from "@/components/site/SiteHeader";
import { HeroSlider } from "@/components/site/HeroSlider";
import { WaButton, StickyCta, FloatingWhatsApp } from "@/components/site/Cta";
import { FaqList } from "@/components/site/FaqList";
import { WA_LINK, LOGO, WHY, FEATURES, STEPS, FAQ } from "@/components/site/content";

const Y = "text-[#ffcc00]";

const Img = ({ src, alt, className = "" }) => (
  <a href={WA_LINK} className="block"><img src={src} alt={alt} loading="lazy" className={`w-full h-auto rounded-xl ${className}`} /></a>
);

export default function Landing() {
  return (
    <div className="da-site bg-black text-white min-h-screen pb-16">
      <SiteHeader />
      <HeroSlider />

      <section className="max-w-5xl mx-auto px-5 py-16 text-center rise">
        <h1 className="da-h text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Online <span className={Y}>Cricket ID</span> (2026) – India's Best Cricket ID Provider | DaddyAnna
        </h1>
        <h2 className={`da-h text-lg md:text-xl font-semibold mt-6 ${Y}`}>Online Cricket ID with DaddyAnna – Get in 2 Minutes</h2>
        <p className="text-white/80 mt-4 max-w-3xl mx-auto">
          If you are looking for a trusted Cricket ID and a 100% safe ID, DaddyAnna is the best choice. Get your Cricket ID in just 2 minutes and start playing on India's No.1 platform.
        </p>
        <div className="mt-8"><WaButton size="lg" testid="hero-whatsapp-button">Get Cricket ID – WhatsApp Now</WaButton></div>
      </section>

      <section id="about" className="max-w-5xl mx-auto px-5 pb-16 text-center">
        <h3 className={`da-h text-lg md:text-xl font-semibold ${Y}`}>India's No.1 Platform for Online Cricket ID, Live Casino & Sports Exchange</h3>
        <p className="text-white/80 mt-4 leading-relaxed">
          Cricket is not merely a sport; it is an emotion. If you wish to elevate your enjoyment of every match, the official DaddyAnna Online Cricket ID is designed for you. We offer verified online <span className={Y}>betting IDs</span> that are 100% safe, fast and easy to use. Whether it is the IPL, the World Cup or any domestic T20 league, you will find every match live with real-time odds.
        </p>
        <div className="max-w-xl mx-auto mt-8"><Img src="/assets/wa-banner.png" alt="DaddyAnna Cricket ID WhatsApp Contact" /></div>
      </section>

      <section className="max-w-7xl mx-auto px-5 py-16 grid md:grid-cols-2 gap-10">
        <div className="da-card">
          <h2 className="da-h text-2xl md:text-3xl font-bold">Online Cricket ID (2026) – India's Best Cricket Betting ID Provider</h2>
          <p className="text-white/80 mt-5 leading-relaxed">
            Searching for Online Cricket ID providers to start playing on live matches? With the rapid growth of cricket in India, more users prefer a quick way to access exchange platforms directly from their mobile — DaddyAnna gives you a verified Cricket ID on WhatsApp in minutes.
          </p>
          <p className="text-white/60 text-sm mt-5">18+ Only | Play Responsibly. DaddyAnna Online Cricket ID has been a trusted ID service in India since 2015. Engaging in betting may result in financial loss — please play within your limits.</p>
          <div className="mt-8 rounded-xl border border-[#ffcc00]/30 bg-[#ffcc00]/5 p-5">
            <p className="font-bold text-[#ffcc00]">Important Announcement</p>
            <p className="text-white/85 text-sm mt-2 leading-relaxed">अगर किसी वजह से हमारा Deposit या Withdrawal नंबर पर मैसेज डिलीवर नहीं होता है तो कृपा करके नीचे दिए गए लिंक पर क्लिक करके नए नंबर पर मैसेज करें और बिना रुके Deposit और Withdrawal करें।</p>
            <p className="text-white/85 text-sm mt-2 leading-relaxed">If our Deposit or Withdrawal number does not deliver messages, click below to get the updated number and enjoy uninterrupted Cricket ID services.</p>
            <div className="mt-5"><WaButton testid="announcement-whatsapp-button">यहाँ क्लिक करे</WaButton></div>
          </div>
        </div>
        <div className="da-card text-center">
          <img src={LOGO} alt="DaddyAnna logo" className="h-12 mx-auto" />
          <h2 className="da-h text-2xl md:text-3xl font-bold mt-6">Get <span className={Y}>Online Cricket ID</span> with DaddyAnna</h2>
          <p className="text-white/80 mt-5 leading-relaxed text-left">
            Obtain an online Cricket ID and enjoy cricket, casino and 650+ games. Our services include 24/7 withdrawal and deposit options. Operating since 2015, we are recognised as the most reliable provider of online Cricket betting IDs in India.
          </p>
          <p className="text-white/80 mt-4 leading-relaxed text-left">
            With live IPL scores, updated match information and casino games all day, the <span className={Y}>DaddyAnna online Cricket ID</span> is the place to be. Simply send us a WhatsApp message and receive your ID in under a minute.
          </p>
          <div className="mt-8"><WaButton testid="about-whatsapp-button">Click Now</WaButton></div>
        </div>
      </section>

      <section id="how-to-play" className="max-w-7xl mx-auto px-5 py-16">
        <h2 className="da-h text-2xl md:text-3xl font-bold text-center">How to Get Your <span className={Y}>Cricket ID</span> in 4 Steps</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {STEPS.map(([src, title, text], i) => (
            <div key={title} data-testid={`step-card-${i}`} className="da-card text-center hover:border-[#ffcc00]/60 hover:-translate-y-1 transition-[transform,border-color]">
              <img src={src} alt={`Cricket ID step ${i + 1}`} loading="lazy" className="h-28 mx-auto object-contain" />
              <p className={`font-bold mt-4 ${Y}`}>Step {i + 1}</p>
              <h3 className="da-h font-semibold text-lg mt-1">{title}</h3>
              <p className="text-white/70 text-sm mt-2">{text}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="why-us" className="max-w-7xl mx-auto px-5 py-16 grid md:grid-cols-2 gap-10 items-center">
        <Img src="/assets/offer.png" alt="Cricket ID Offer" />
        <div>
          <h2 className="da-h text-2xl md:text-3xl font-bold">Why Choose <span className={Y}>DaddyAnna</span> Online Cricket ID?</h2>
          <div className="mt-8"><FaqList items={WHY} prefix="why" /></div>
        </div>
      </section>

      <section id="features" className="max-w-7xl mx-auto px-5 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="da-h text-2xl md:text-3xl font-bold">Online <span className={Y}>Cricket ID</span> by DaddyAnna</h2>
          <p className="text-white/80 mt-5 leading-relaxed">Since 2015, DaddyAnna has been a reputable provider of online Cricket IDs and casino IDs, with user-friendly platforms, instant Cricket ID service and 24/7 deposits & withdrawals.</p>
          <ul className="grid sm:grid-cols-2 gap-3 mt-8">
            {FEATURES.map((f, i) => (
              <li key={f} data-testid={`feature-item-${i}`} className="flex items-start gap-2.5 text-white/90">
                <CheckCircle2 className="w-5 h-5 text-[#25a244] shrink-0 mt-0.5" /> {f}
              </li>
            ))}
          </ul>
          <div className="mt-8"><WaButton testid="features-whatsapp-button">Get Cricket ID Now</WaButton></div>
        </div>
        <Img src="/assets/dp.png" alt="Online Cricket ID DaddyAnna" className="max-w-md mx-auto" />
      </section>

      <section className="max-w-7xl mx-auto px-5 py-16 grid md:grid-cols-2 gap-10 items-center">
        <Img src="/assets/bonus.png" alt="DaddyAnna Cricket ID Welcome Bonus" className="max-w-md mx-auto" />
        <div>
          <h2 className="da-h text-2xl md:text-3xl font-bold">DaddyAnna Kya Hai?</h2>
          <p className="text-[#ffcc00] mt-5">DaddyAnna is a trusted provider of Sports Exchange and Gaming IDs. With our Cricket ID you can:</p>
          <ul className="mt-4 space-y-2 text-white/85 list-disc pl-5">
            <li>Get an Online Cricket ID in just 2 minutes.</li>
            <li>Play Live Cricket, Football and Tennis.</li>
            <li>Enjoy 250+ live casino games like Teen Patti, Andar Bahar, Roulette and Aviator.</li>
            <li>Make instant deposits and withdrawals via UPI, Bank and USDT.</li>
          </ul>
          <p className="da-h text-[#00e5ff] font-semibold mt-6">Our objective is simple – a seamless, transparent and swift Cricket ID experience, without any delays.</p>
        </div>
      </section>

      <section id="faq" className="max-w-4xl mx-auto px-5 py-16">
        <h2 className="da-h text-2xl md:text-3xl font-bold text-center">Cricket ID – Frequently Asked Questions</h2>
        <div className="mt-10"><FaqList items={FAQ} prefix="faq" accent="text-white" /></div>
        <div className="text-center mt-10"><WaButton size="lg" testid="faq-whatsapp-button">Get Cricket ID – WhatsApp Now</WaButton></div>
      </section>

      <footer className="border-t border-white/10 mt-8">
        <div className="max-w-7xl mx-auto px-5 py-10 text-center text-white/50 text-xs leading-relaxed space-y-4">
          <img src={LOGO} alt="DaddyAnna" className="h-10 mx-auto" />
          <p>Access to this site is restricted in certain geographical territories. Customers residing in the listed territories are prohibited from accessing the site and its services.</p>
          <p>18+ Only | Play Responsibly. © {new Date().getFullYear()} DaddyAnna – Online Cricket ID Provider.</p>
        </div>
      </footer>

      <FloatingWhatsApp />
      <StickyCta />
    </div>
  );
}
